import React, { useState } from 'react';
import Picker from 'react-mobile-picker';
import styles from './NumberPicker.module.css';

export interface NumberPickerProps {
    selections: {
        distance: string[];
    };
    value: { distance: string };
    onChange: (value: { distance: string }) => void;
}

export const NumberPicker: React.FC<NumberPickerProps> = ({ selections, value, onChange }) => {
    const [internalValue, setInternalValue] = useState<{ distance: string }>(value || { distance: selections.distance[0] });

    const handleChange = (val: { distance: string }) => {
        setInternalValue(val);
        onChange(val);
    };

    const pickerValue = value || internalValue;

    return (
        <Picker value={pickerValue} onChange={handleChange} wheelMode="natural" className={styles.picker}>
            <Picker.Column name="distance">
                {selections.distance.map((option) => (
                    <Picker.Item key={option} value={option}>
                        {({ selected }) => <div className={selected ? styles.selectedItem : styles.unselectedItem}>{option}</div>}
                    </Picker.Item>
                ))}
            </Picker.Column>
        </Picker>
    );
};
